/**
 * Top-left HUD pill — breadcrumb of the focal path.
 *
 * Renders only the pill itself; the surrounding placement (top-left
 * corner in BoardChrome, or wherever the host wants it in a custom
 * layout) is up to the parent.
 */
import { Breadcrumb } from "../Breadcrumb";
import type { FocalStep } from "@archlang/scene/board";

export function BreadcrumbHud({
  steps,
  onNavigate,
}: {
  readonly steps: readonly FocalStep[];
  readonly onNavigate: (index: number) => void;
}) {
  return (
    <div
      // max-w + overflow-x: a deep focal path on a portrait phone scrolls
      // inside the pill instead of running under the top-right controls.
      className="pointer-events-auto max-w-full overflow-x-auto rounded-lg bg-slate-900/(--tint-strong) backdrop-blur-md border border-slate-700 px-3 py-2 pointer-coarse:px-2 pointer-coarse:py-1 shadow-lg"
      data-hud
      data-hud-region="breadcrumb"
      onClick={(e) => e.stopPropagation()}
    >
      <Breadcrumb steps={steps} onNavigate={onNavigate} />
    </div>
  );
}
